module.exports = __webpack_public_path__ + "img/application_rejected_icon.4d605d9e.svg";